import { Vector } from './Vector'

// 5 |
// 4 |         * (4,4)
// 3 |
// 2 |
// 1 |________________
// 0  1  2  3  4  5 
//
// n.p + d = 0  i.e nx*px + ny*py + nz*pz + d = 0
// n is the normal vector to the plane
// p is any point on the plane
// d is the distance from the origin to the plane along the normal vector
export class Plane {
    normal: Vector;
    d: number;

    constructor(normal: Vector, d: number) {
        this.normal = normal;
        this.d = d;
    }

    // f(p) = n.p + d 
    // f(p) > 0  => p is in the positive half-space defined by the plane
    // f(p) < 0  => p is in the negative half-space defined by the plane
    static halfPlaneTest(plane: Plane, position: Vector) {
        return Vector.dotProduct(plane.normal, position) + plane.d;
    }

    static closestPointOnPlane(plane: Plane, point: Vector) {
        // Normalize the plane: both normal and d need to be adjusted
        const normalMagnitude = Vector.magnitude(plane.normal);
        const normalizedPlane = new Plane(
            Vector.normalise(plane.normal), 
            plane.d / normalMagnitude
        );

        // Calculate signed distance from point to plane
        const distance = Plane.halfPlaneTest(normalizedPlane, point);

        // Project point onto plane by moving it along the normal
        return Vector.subtract(point, Vector.scale(normalizedPlane.normal, distance));
    }
}
